export var DEFAULT_GEMINI_USAGE_LEVEL_CONFIG = {
    weeklyThresholds: {
        high: { minTotalInvocations: 20, minActiveDays: 4 },
        medium: { minTotalInvocations: 8, minActiveDays: 2 }
    },
    periodLengthDays: 7
};
export var scaleGeminiUsageLevelThresholds = function (weeklyThresholds, weekCount) { return ({
    high: {
        minTotalInvocations: weeklyThresholds.high.minTotalInvocations * weekCount,
        minActiveDays: weeklyThresholds.high.minActiveDays * weekCount
    },
    medium: {
        minTotalInvocations: weeklyThresholds.medium.minTotalInvocations * weekCount,
        minActiveDays: weeklyThresholds.medium.minActiveDays * weekCount
    }
}); };
